<template>
	<v-app>
		<div class="wrap" :class="[detailStore.isDark ? 'darkmode' : '']">
			<headerLayout @click:mode-chg="mode"></headerLayout>
			<div class="container">
				<leftMenuLayout></leftMenuLayout>
				<div class="content pump">
					<NuxtPage/>
				</div>
			</div>
		</div>
		<v-overlay
			:model-value="isExportDownloading"
			class="export-loading-overlay"
			persistent
		>
			<div class="export-loading-content">
				<v-progress-circular
					class="export-loading-spinner"
					indeterminate
					size="64"
					width="6"
				/>
			</div>
		</v-overlay>
	</v-app>
</template>

<script setup lang="ts">
import {onMounted, watch} from 'vue'
import headerLayout from '~/components/header.vue'
import leftMenuLayout from '~/components/leftMenu2.vue'
import {useDetailStore} from '~/stores/detail'
import {useTheme} from 'vuetify'

const detailStore = useDetailStore()
const theme = useTheme()
const { isExportDownloading } = useExportLoading()

// mode toggle 처리
const mode = (e: { value: boolean }) => {
	const isDark = !e.value
	detailStore.setIsDark(isDark)
	theme.global.name.value = isDark ? 'dark' : 'light'
	document.querySelector('.wrap')?.classList.toggle('darkmode', isDark)
}

// 초기 mount 시 적용
onMounted(() => {
	const isDark = detailStore.isDark
	theme.global.name.value = isDark ? 'dark' : 'light'
	document.querySelector('.wrap')?.classList.toggle('darkmode', isDark)
})

// sessionStorage에 저장
watch(() => detailStore.isDark, (newVal) => {
	sessionStorage.setItem('isDark', newVal.toString())
})
</script>

<style lang="scss" scoped>
.export-loading-overlay :deep(.v-overlay__content) {
	width: 100%;
	height: 100%;
	margin: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.export-loading-content {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.export-loading-spinner :deep(.v-progress-circular__overlay) {
	stroke: rgba(117, 80, 223, 0.5) !important;
}
</style>
